export default {
    namespaced: true,
    state: () => ({
        protocolslist: ['IPv4', 'IPv6']
    }),
    mutations:
    {
        SET_PROTOCOLSLIST(state, val) {
            state.protocolslist = val
        },
    }
}